import React from 'react'
import './AboutOne.css';

function AboutOne() {

  

    return (
        <section
            className="about-area overflow-hidden"
            id="about-sec"
        >

            <div className="container">

                <div className="row align-items-center gy-5">

                    {/* Left Side Images */}
                    <div className="col-xl-5 col-lg-6">

                        <div className="about-images">

                            <div className="main-image">
                                <img
                                    src="/assets/img/normal/about_1_1.jpg"
                                    alt="Mahakal Yatra"
                                />
                            </div>

                            <div className="small-image image-one">
                                <img
                                    src="/assets/img/normal/about_1_2.jpg"
                                    alt="Ujjain Temple"
                                />
                            </div>

                            <div className="small-image image-two">
                                <img
                                    src="/assets/img/normal/about_1_3.jpg"
                                    alt="Mahakal Temple"
                                />
                            </div>

                           <div className="experience-box">
   <h4 className="text-dark" style={{ fontWeight: 1200 }}>10+</h4>
<p className="text-dark" style={{ fontWeight: 1200 }}>Years Experience</p>
</div>

                        </div>
                    </div>

                    {/* Right Side Content */}
                    <div className="col-xl-7 col-lg-6">

                     <div className="about-content">

                    <span className="about-tag text-dark">
                        Har Har Mahadev
                    </span>

                    <h1 className="main-title">
                        MahakalYatra.com: Best Ujjain Tour Packages & Local Guide
                    </h1>

                    <p className="description">
                        <strong>MahakalYatra.com mein aapka hardik swagat hai.</strong>
                        Ujjain nagar matra ek paryatan sthal hi nahi,
                        apitu <strong>moksh ki pawan bhoomi</strong> hai,
                        jahan <strong>kan-kan mein Shiv</strong> baste hain.
                        Ujjain aana evam
                        <strong> Mahakaleshwar Jyotirlinga mein Baba Mahakal </strong>
                        ka aashirwad prapt karna pratyek Shiv bhakt ka sapna hota hai.
                    </p>

                    <p className="description">
                        Isi sapne ki purti ke liye,
                        <strong> MahakalYatra.com </strong>
                        ka uddeshya Baba ki nagari mein aapke kadam rakhne se lekar
                        aapki samast chintaon ko door karna aur aapko ek perfect
                        <strong> Ujjain Darshan Itinerary </strong>
                        pradan karna hai.
                    </p>

                    <p className="description">
                        Jahan ek hi sthan par aapke liye
                        <strong>
                            budget-friendly hotels in Ujjain near Mahakal Temple,
                            guest house evam homestay, bhojan,
                            sampoorn Ujjain darshan,
                            customized couple tours,
                            rental bike, e-rickshaw in Ujjain
                            ya aapki solo trip
                        </strong>
                        ki suvidha uplabdh hai.
                        Hum aapki budget aur suvidha ke anusar
                        poori yatra ko
                        <strong> sugam, surakshit aur aadhyatmik </strong>
                        roop se plan karte hain.
                    </p>

                        <p className="description">
                            Hamara lakshya keval service provide karna hi nahi,
                            balki Baba ki nagari mein aapke kadam rakhne se lekar wapsi tak
                            ek <em>"local travel guide evam dost"</em>
                            ki tarah aapka saath dena hai.
                            Hum chahte hain ki aap apni yatra ki chintaon ko hamein saunp dein
                            aur <strong>poori tanmayta se Baba Mahakal ki bhakti</strong>
                            mein leen ho jayein.
                        </p>

                        </div>
                        </div>

    {/* Services Section */}
                         <div className="about-content">


    <div className="services-wrapper">

        <h2 className="section-title">
            Hamari Suvidhayein - Top Ujjain Tourism Services
        </h2>

        <div className="row gy-4">

            <div className="col-md-6">

                <div className="service-card">

                    <div className="service-icon">
                        <i className="fas fa-hotel"></i>
                    </div>

                    <div className="service-content">

                        <h5>
                            Best Hotels & Comfortable Stay in Ujjain
                        </h5>

                        <p>
                            Hotel rooms, guest house aur homestays ki suvidha,
                            jahan aapko ghar jaisa anubhav hota hai.
                        </p>

                    </div>

                </div>

            </div>

            <div className="col-md-6">

                <div className="service-card">

                    <div className="service-icon">
                        <i className="fas fa-motorcycle"></i>
                    </div>

                    <div className="service-content">

                        <h5>
                            E-Rickshaw & Bike Rent in Ujjain
                        </h5>

                        <p>
                            Solo/couple yatriyon ke liye
                            budget-friendly rental bikes aur e-rickshaw service.
                        </p>

                    </div>

                </div>

            </div>

            <div className="col-md-6">

                <div className="service-card">

                    <div className="service-icon">
                        <i className="fas fa-car"></i>
                    </div>

                    <div className="service-content">

                        <h5>
                            Omkareshwar Tour & Taxi Services
                        </h5>

                        <p>
                            Omkareshwar Jyotirlinga aur aas-paas ke sthanon ke liye
                            cab booking aur taxi facilities.
                        </p>

                    </div>

                </div>

            </div>

            <div className="col-md-6">

                <div className="service-card">

                    <div className="service-icon">
                        <i className="fas fa-place-of-worship"></i>
                    </div>

                    <div className="service-content">

                        <h5>
                            Temple Darshan & Sightseeing
                        </h5>

                        <p>
                            Mahakaleshwar, Kaal Bhairav,
                            Harsiddhi Mata aur anya prachin mandiron ka darshan.
                        </p>

                    </div>

                </div>

            </div>

        </div>

    </div>

    {/* Pooja Section */}

    <div className="why-choose-box">

        <h2>
            Ujjain Pooja Vishesh
        </h2>

        <p>
            Mangal Dosh, Kaalsarp Dosh aur anya
            Vedic Anushthan ke liye anubhavi panditon dwara
            poorn vidhi-vidhan ke saath pooja sampann karayi jaati hai.
        </p>

        <ul>
            <li>
                ✔ Mangalnath Temple - Mangal Pooja & Bhat Pooja
            </li>

            <li>
                ✔ Kaalsarp Dosh Nivaran Pooja in Ujjain
            </li>

            <li>
                ✔ Mahamrityunjay Jaap & Rudrabhishek
            </li>

            <li>
                ✔ Jyotish Paramarsh & Kundali Nirman
            </li>
        </ul>

    </div>

    {/* Why Choose */}

    <div className="why-choose-box">

        <h2>
            Hum Doosron Se Alag Kyon Hain?
        </h2>

        <p>
            Jahan log sirf trip bechte hain,
            wahan hum ek
            <strong> meetha anubhav aur yaadon ki mala </strong>
            pirote hain.
        </p>

        <ul>
            <li>✔ Local Travel Guide Support</li>
            <li>✔ Budget & Premium Stay Options</li>
            <li>✔ Temple Darshan Assistance</li>
            <li>✔ Customized Family & Couple Packages</li>
            <li>✔ Trusted Pooja & Pandit Services</li>
        </ul>

    </div>

    {/* Button */}

    {/* <div className="btn-wrapper">

        <a href="/contact" className="theme-btn">
            Book Your Spiritual Journey
        </a>

    </div> */}

    <div className="mahadev-line">
        Har Har Mahadev — Jai Jai Shiv Shambhu!
    </div>



                    </div>

                </div>

            </div>

        </section>
    )
}

export default AboutOne;